import { searchCatalog, optionOf, optionSummary } from "./catalog.js";
import { groupKey } from "./searchParts.js";

const OPTIONS_PER_SEARCH = 8;

export default {
  definition: {
    name: "search_parts_by_text",
    description:
      "Busca piezas por descripción y le muestra hasta 8 opciones al vendedor en una tarjeta donde marca todas las que necesita (son piezas distintas: el bumper, su barra, sus soportes), cada una con su cantidad; las marcadas entran a la cotización igual que las de search_parts. Los títulos del catálogo están en inglés: pasa query en inglés con el nombre de la pieza en términos de repuestos ('alternator', 'front brake shoes', 'water pump'), sin el vehículo. Con useVehicle true sólo salen las piezas que le quedan al vehículo elegido con find_vehicle. Si no sale nada, prueba un sinónimo o un término más general.",
    strict: true,
    input_schema: {
      type: "object",
      properties: {
        query: {
          type: "string",
          description: "Nombre de la pieza en inglés, sin el vehículo"
        },
        label: {
          type: "string",
          description:
            "Cómo la pidió el vendedor, para el encabezado de la tarjeta (p. ej. 'alternador')"
        },
        quantity: {
          type: "integer",
          description: "Cantidad pedida; 1 si no la dijo"
        },
        useVehicle: {
          type: "boolean",
          description:
            "true para filtrar por el vehículo elegido; false para buscar en todo el catálogo"
        }
      },
      required: ["query", "label", "quantity", "useVehicle"],
      additionalProperties: false
    }
  },

  async run({ query, label, quantity, useVehicle }, ctx) {
    const { vehicle } = ctx.getSelection();
    if (useVehicle && !vehicle) {
      throw new Error(
        "No hay vehículo elegido: búscalo con find_vehicle y espera a que el vendedor lo elija, o busca sin vehículo."
      );
    }
    const hits = await searchCatalog(ctx, query, OPTIONS_PER_SEARCH, {
      filterByVehicle: useVehicle
    });
    const forVehicle = useVehicle ? vehicle : null;
    // Una pieza por búsqueda y vehículo: buscar lo mismo otra vez actualiza
    // la misma pieza en lugar de sumar otra
    const group = {
      key: groupKey(`text:${query}|${forVehicle ? forVehicle.key : ""}`),
      code: forVehicle ? `${label} · ${forVehicle.label}` : label,
      quantity: Math.max(1, quantity || 1),
      // Las opciones son piezas distintas (el bumper, su barra, sus
      // soportes): el vendedor marca todas las que necesita
      multiple: true,
      options: hits.map(hit => optionOf(hit, ctx))
    };
    return {
      card: { type: "partOptions", groups: [group] },
      content: JSON.stringify({
        shownToUserAsCard: true,
        // Puede marcar varias, cada una con su cantidad
        multipleChoice: true,
        query,
        vehicle: forVehicle ? `${forVehicle.label} ${forVehicle.engine}` : null,
        found: group.options.length,
        selected: group.options.length === 1 ? group.options[0].nkrCode : null,
        options: group.options.map(optionSummary)
      })
    };
  }
};
